import React, { useState, useEffect } from "react";
import axios from "../../../library/axios";
import { MySwal } from "../../../library/swal";
import Button from "react-bootstrap/Button";
import { IconSquareX } from "@tabler/icons-react";
import Table from 'react-bootstrap/Table';
import { getSlug, } from "../../../../src/config/routes/guards/slug";
import { formatDate } from '../../../helpers/formatDate';
import { notifyApiLoadError } from '../../../helpers/notifyApiError';

const DetailUserComp = (props) => {

  const [user, setUser] = useState([]);

  const fetchData = async () => {
    try {
      const options = {
        url: `/users/detailUserParam/${props?.user?.id}`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data)
      setUser(data);
    } catch (err) {
      notifyApiLoadError(err, 'components/moleculs/users/detail.fetchData');
    }
  };

  useEffect(() => {
    fetchData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <div className="row">
        <div className="col-12">
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Username</th>
                <th> : </th>
                <th>{user?.username}</th>
              </tr>
              <tr>
                <th>Nama Lengkap</th>
                <th> : </th>
                <th>{user?.namaLengkap}</th>
              </tr>
              <tr>
                <th>Nomor Induk Karyawan (NIK)</th>
                <th> : </th>
                <th>{user?.nik}</th>
              </tr>
              <tr>
                <th>Email</th>
                <th> : </th>
                <th>{user?.email}</th>
              </tr>
              <tr>
                <th>Jabatan</th>
                <th> : </th>
                <th>{user?.jabatan}</th>
              </tr>
              <tr>
                <th>Divisi</th>
                <th> : </th>
                <th>{user?.risk_division?.namaDivision}</th>
              </tr>
              <tr>
                <th>Group / Role</th>
                <th> : </th>
                <th>{user?.mapping_user_groups?.[0]?.group?.namaGroup}</th>

              </tr>
              <tr>
                <th>Status</th>
                <th> : </th>
                <th>{user?.active === "YES" ? "Aktif" : "Tidak Aktif"}</th>
              </tr>
            </thead>
          </Table>
        </div>
      </div>
      <hr></hr>
      <div className="row">
        <h4 className="text-info">Tabel Akses Bab</h4>
        <div className="col-12">
          <Table striped bordered hover>
            <thead className="bg-info border-1 text-center text-white">
              <tr>
                <th>Standard Akreditasi</th>
                <th>Bab</th>
              </tr>
            </thead>
            <tbody className="border-1">
              {user?.mapping_user_chapters?.map((row) => (
                <tr>
                  <td className="text-center">{row?.standards_accreditation?.Nama}</td>
                  <td>{row?.chapters_accreditation?.Deskripsi} ({row?.chapters_accreditation?.Singkatan})</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>

      <div className="mt-5 row">
        <div className="d-flex flex-center flex-row-fluid pt-2">
          <Button variant="danger" size="sm" onClick={() => props.close()}>
            <IconSquareX stroke={2} /> Tutup
          </Button>
        </div>
      </div>
    </>
  );
};

export default DetailUserComp;
